module.exports = __webpack_public_path__ + "static/Pastry05-1937f8421c5a02a5f3ebe800e44243a4.png";